/** English hydrate label + CMS/Saleor slug → next-intl key (BEC-24924). */
export const MANUFACTURED_BY_LABEL_KEYS = {
  'Manufactured by': 'technicalData.movement.manufacturedBy',
  'Product.TechnicalData.Movement.ManufacturedBy': 'technicalData.movement.manufacturedBy',
} as const;
